import { render, staticRenderFns } from "./tabHBLUICustomLayout.vue?vue&type=template&id=15e86ddc&"
import script from "./tabHBLUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabHBLUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e86ddc')) {
      api.createRecord('15e86ddc', component.options)
    } else {
      api.reload('15e86ddc', component.options)
    }
    module.hot.accept("./tabHBLUICustomLayout.vue?vue&type=template&id=15e86ddc&", function () {
      api.rerender('15e86ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabHBLUICustomLayout.vue"
export default component.exports